/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_Tab_SubscriptionInputs */

const en_settings_payments_tab_subscription = /** @type {(inputs: Settings_Payments_Tab_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Settings_Payments_Tab_SubscriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_payments_tab_subscription = /** @type {((inputs?: Settings_Payments_Tab_SubscriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_Tab_SubscriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_payments_tab_subscription(inputs)
});
export { settings_payments_tab_subscription as "settings.payments.tab_subscription" }